import Skeleton from 'react-loading-skeleton';

export default function ProtectionShadingTabs({
    vehicle,
    trans,
    lang,
    isLoading,
    models,
    activeModel,
    afterChangeDataType,
    setActiveModel,
}) {
    return (
        <section className="sec clr-sec" style={{ marginTop: '30px' }}>
            <div className="ctn rv vis d1">
                <style>{`
                    .car-colors-models-wrapper {
                        background: var(--surface);
                        border: 1px solid rgba(0,0,0,.04);
                        border-radius: var(--r);
                        padding: 30px;
                        box-shadow: 0 4px 20px rgba(0,0,0,.04);
                    }
                    .tr-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
                        gap: 16px;
                    }
                    .tr-card {
                        background: var(--bg2);
                        padding: 20px;
                        border-radius: 16px;
                        border: 2px solid transparent;
                        cursor: pointer;
                        transition: all .3s ease;
                        position: relative;
                        overflow: hidden;
                    }
                    .tr-card.active {
                        border-color: var(--g);
                        background: var(--bg);
                    }
                    .tr-badge {
                        position: absolute;
                        top: 0;
                        right: 0;
                        background: var(--g);
                        color: #fff;
                        padding: 4px 12px;
                        font-size: 11px;
                        font-weight: 800;
                        border-bottom-left-radius: 12px;
                    }
                    .tr-hl {
                        color: var(--g);
                        font-weight: 800;
                        font-size: 14px;
                    }
                `}</style>
                <div className="car-colors-models-wrapper">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px' }}>
                        <span style={{ width: '4px', height: '18px', borderRadius: '2px', background: 'var(--g)' }}></span>
                        <h3 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--t1)', margin: 0 }}>
                            {trans('new:categories')}
                        </h3>
                    </div>

                    <div>
                        {isLoading ? (
                            <Skeleton count={1} borderRadius="16px" width="100%" height="90px" />
                        ) : models && models.length > 0 && (
                            <div className="tr-grid">
                                {models.map((model, index) => {
                                    const name = lang === 'ar'
                                        ? (model.shortDescription ?? model.modelDescription)?.replace(model?.brand, '')?.replace(model?.group, '')
                                        : (model.shortDescriptionEn ?? model.modelDescription)?.replace(model?.brand, '')?.replace(model?.group, '')
                                    const isActive = activeModel?.type === model.type;
                                    return (
                                        <div
                                            key={index}
                                            className={`tr-card ${isActive ? 'active' : ''}`}
                                            onClick={() => {
                                                if (!isActive) {
                                                    afterChangeDataType(model);
                                                    setActiveModel(model);
                                                }
                                            }}
                                        >
                                            {isActive && <div className="tr-badge">{trans('new:selected')}</div>}
                                            <h4>{name}</h4>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
